import { IApplicationState } from '../../types/redux';

export const selectFloorsFilter = (state: IApplicationState) => {
  const { savedFilters } = state.filters;

  return savedFilters.floors || [];
};
